<template>
  <span
    v-bind="$attrs"
    :class="['d-flex align-items-center w-100', { 'with-shadow py-2 px-1 mb-2 sdui-shadow br-8 border': withShadow }]"
    data-cy="header-nav-wrapper"
  >
    <span>
      <!-- classbook svg -->
      <img v-if="selectedEntity === 'grades'"
           src="/img/classbook/classbook.svg"
           alt=""
           loading="lazy"
      />

      <!-- entity mixin for users -->
      <sdui-icon
        v-else-if="selectedEntity === 'users'"
        :class="entity.iconClass || userProps(entity)"
        variant="''"
        bg-variant="''"
        data-cy="user-icon"
      />

      <!-- courses shortcut -->
      <sdui-icon v-else
                 :class="`white ${validEntity && metaData.color}-dark-bg`"
                 :variant="''"
                 bg-variant="''"
      >
        <span>
          {{ validEntity && metaData.shortname }}
        </span>
      </sdui-icon>
    </span>

    <span class="ml-2">
      <p class="font-weight-bold mb-0">
        {{ validEntity && metaData.displayname }}
        {{ !isHeaderNavigation && entity.id === $me.id ? $t('classbook.entities.my_account') : '' }}
      </p>

      <small v-if="!hideDescription" class="text-muted">{{ validEntity && metaData[entityDescription] }}</small>
    </span>
  </span>
</template>

<script>
import entityMixin from 'src/mixins/miscellaneous/entityMixin.js'

export default {
  name: 'ClassbookEntityItemDisplay',
  mixins: [entityMixin],
  props: {
    entity: {
      type: Object,
      required: true,
    },

    isHeaderNavigation: {
      type: Boolean,
      required: false,
    },

    selectedEntity: {
      type: String,
      required: true,
    },

    hideDescription: {
      type: Boolean,
      default: false,
    },

    withShadow: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    validEntity() {
      return this.entity && Object.keys(this.entity).length
    },

    metaData() {
      return this.entity?.meta
    },

    entityDescription() {
      if (this.selectedEntity === 'grades') return 'users_count'
      if (this.selectedEntity === 'courses') return 'name'
      return 'subtitle'
    },
  },
}
</script>

<style scoped lang="scss">
// TODO: fix naming to align with conventions
.with-shadow {
  box-shadow: $sdui-shadow;
}
</style>
